import { Pipe, PipeTransform } from '@angular/core';

const jedec = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

@Pipe({
  name: 'filesize',
  standalone: true,
})
export class FileSizePipe implements PipeTransform {
  transform(value: string | number | null | undefined): string {
    if (value == null || value === undefined) {
      return 'N/A'; // nebo jakákoliv jiná výchozí hodnota nebo zpráva
    }

    const bytes = typeof value === 'string' ? parseFloat(value) : value;

    if (isNaN(bytes)) {
      return 'N/A'; // nebo jakákoliv jiná výchozí hodnota nebo zpráva
    }

    return this._getValue(bytes).replace('.', ',');
  }

  private _getValue(bytes: number): string {
    bytes = Math.abs(bytes);
    let loop = 0;

    while (bytes >= 1024) {
      bytes /= 1024;
      ++loop;
    }
    return `${bytes.toFixed(2)} ${jedec[loop]}`;
  }
}
